import Link, {
  BlueLink,
  DangerLink,
  DarkGrayLink,
  DeepBlueBoldLink,
  DeepBlueLink,
  EditLink,
  GreenLink,
  GreyLink,
  LightGrayLink,
} from '~/components/Link/Link';

export default Link;
export { GreenLink };
export { BlueLink };
export { DeepBlueLink };
export { DeepBlueBoldLink };
export { GreyLink };
export { EditLink };
export { DangerLink };
export { LightGrayLink };
export { DarkGrayLink };
